import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetManufacturersQuery } from "../../redux/api/manufacturersApi";
import { 
  Table, 
  Button, 
  Typography, 
  Alert, 
  Space 
} from "antd";
import { EyeOutlined, EditOutlined, PlusOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const ManufacturersPage = () => {
  const navigate = useNavigate();
  const { data: manufacturers = [], isLoading, error } = useGetManufacturersQuery();

  // Table columns configuration
  const columns = [
    {
      title: 'ID',
      dataIndex: 'manufacturer_id',
      key: 'manufacturer_id',
      width: '8%',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: 'Contact Person',
      dataIndex: 'contact_person',
      key: 'contact_person',
      width: '18%',
    },
    {
      title: 'Contact',
      key: 'contact',
      width: '32%',
      render: (_, record) => (
        <div style={{ lineHeight: '1.8' }}>
          {record.contact_email ? (
            <div>
              <MailOutlined style={{ marginRight: 6, color: '#8c8c8c' }} />
              <Text type="secondary" style={{ fontSize: '0.875rem' }}>{record.contact_email}</Text>
            </div>
          ) : null}
          {record.contact_phone ? (
            <div>
              <PhoneOutlined style={{ marginRight: 6, color: '#8c8c8c' }} />
              <Text type="secondary" style={{ fontSize: '0.875rem' }}>{record.contact_phone}</Text>
            </div>
          ) : null}
        </div>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '22%',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => navigate(`/manufacturers/${record.manufacturer_id}`)}
            title="View"
          >
            View
          </Button>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => navigate(`/manufacturers/${record.manufacturer_id}/edit`)}
            title="Edit"
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <Alert title="Loading manufacturers..." type="info" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error loading manufacturers"
        description={error?.data?.message || error?.error || 'Failed to load manufacturers'}
        type="error"
        showIcon
      />
    );
  }

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <Title level={1} style={{ margin: 0 }}>Manufacturers</Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/manufacturers/add")}
        >
          Add Manufacturer
        </Button>
      </div>

      {manufacturers.length === 0 ? (
        <Alert
          message="No manufacturers found"
          description="No manufacturers available."
          type="info"
          showIcon
        />
      ) : (
        <Table
          columns={columns}
          dataSource={manufacturers}
          rowKey="manufacturer_id"
          pagination={false}
          size="middle"
        />
      )}
    </div>
  );
};

export default ManufacturersPage;
